import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on every route change. Overrides CSS scroll-behavior:smooth
 * for the navigation itself so the new page lands at the top instantly,
 * but lets anchor links (#section) still scroll smoothly.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // small delay to ensure target is mounted
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
      return;
    }
    // Temporarily disable smooth scrolling so navigation lands instantly at top
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    document.body.scrollTop = 0; // Safari
    // Restore after a tick
    requestAnimationFrame(() => { html.style.scrollBehavior = prev; });
  }, [pathname, hash]);

  return null;
}
